<template>
    <form v-if="!loading" class="form-horizontal">
        <b-alert
            show
            variant="warning"
            v-if="data.isDefaultProvider && data.bundle_id.length > 0"
        >
            <span id="dialog-alert-message">
                {{ CLINIC_PROVIDER_ALERT.LAB_RADIOLOGY_BUNDLE }}
            </span>
        </b-alert>
        <div class="form-group row">
            <label for="title" class="col-sm-3 col-form-label">Title:</label>
            <div class="col-sm-9">
                <input
                    id="title"
                    v-model="data.title"
                    v-validate="'required'"
                    :class="{ 'border-danger': errors.has('title') }"
                    type="text"
                    class="form-control"
                    name="title"
                    placeholder="Estimate name (required)"
                />
            </div>
        </div>
        <div class="form-group row" v-if="!isClientExist">
            <label for="client_id" class="col-sm-3 col-form-label"
                >Client:</label
            >
            <div class="col-sm-9">
                <vet-select
                    id="client_id"
                    v-model="data.client"
                    v-validate="''"
                    :show-menu="false"
                    module="client"
                    placeholder="Client Name (optional)"
                    name="client_id"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="staticEmail" class="col-sm-3 col-form-label"
                >Patient:</label
            >
            <div class="col-sm-9">
                <vet-select
                    id="patient_id"
                    v-model="data.patient"
                    :disabled="!(data.client && data.client.id)"
                    v-validate
                    :client-id="data.client_id"
                    :options="poptions"
                    :show-menu="false"
                    module="client-patient"
                    placeholder="Patient Name (optional)"
                    label="name"
                    name="patient_id"
                    :status="[1, 3]"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="provider" class="col-sm-3 col-form-label"
                >Provider:</label
            >
            <div class="col-sm-9">
                <v-select
                    id="staffs"
                    ref="vselect"
                    :options="staffList"
                    v-model="data.staff"
                    :label="'fullname'"
                    placeholder="Provider (optional)"
                />
            </div>
        </div>
        <div
            v-if="$root.setting && _.includes([1, 2], $root.setting.location)"
            class="form-group row"
        >
            <label for="location" class="col-sm-3 col-form-label"
                >Location:</label
            >
            <div class="col-sm-9">
                <select
                    id="location"
                    v-model="data.location"
                    class="form-control"
                >
                    <option :value="null" v-if="$root.setting.location == 2">
                        In Clinic
                    </option>
                    <option
                        :value="null"
                        v-if="!data.client_id && $root.setting.location == 1"
                    >
                        Select location (optional)
                    </option>
                    <option
                        v-for="location in locations"
                        :key="location.id"
                        :value="location"
                    >
                        {{ location.name }}{{ location.address }}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group row">
            <label for="start" class="col-sm-3 col-form-label">Created:</label>
            <div class="col-sm-9">
                <date-picker
                    id="start"
                    :config="datePickerOptions"
                    v-model="data.start"
                    class="form-control"
                    placeholder="Create Date (required)"
                    name="start"
                ></date-picker>
            </div>
        </div>
        <div class="form-group row">
            <label for="expire" class="col-sm-3 col-form-label"
                >Valid Until:</label
            >
            <div class="col-sm-9">
                <date-picker
                    id="expire"
                    :config="datePickerOptions"
                    v-model="data.expire"
                    class="form-control"
                    placeholder="Expire Date (required)"
                    name="expire"
                ></date-picker>
            </div>
        </div>
        <div class="form-group row">
            <label for="bundle" class="col-sm-3 col-form-label">Bundle:</label>
            <div class="col-sm-9">
                <v-select
                    id="bundle"
                    ref="vselect"
                    :options="bundle_options_exclude"
                    v-model="data.bundle_id"
                    placeholder="Select bundle (optional)"
                    multiple
                    label="name"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="notes" class="col-sm-3 col-form-label">Notes:</label>
            <div class="col-sm-9">
                <editable
                    id="notes"
                    v-model="data.note"
                    placeholder="Notes (optional)"
                    :defaultHeight="64"
                ></editable>
            </div>
        </div>
    </form>
</template>
<style></style>
<script>
import { difference, isEmpty, find, get } from "lodash";
import vSelect from "vue-select";
import Client from "@/services/client";
import Templates from "@/services/templates";
import vetSelect from "@/module/commons/vet-select.vue";
import CLINICPROVIDER from "@/constants/clinic-provider";
import Patient from "@/services/patient";
import TEMPLATES from "@/constants/templates";
import Editable from "@/components/elements/editable-textarea";

export default {
    components: {
        vetSelect,
        vSelect,
        Editable
    },
    props: {
        data: {
            type: Object,
            default() {}
        },
        client: {
            type: Object,
            default() {}
        },
        parentLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            bundle_data: {
                bundle_id: null,
                selectedElements: []
            },
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            loading: false,
            poptions: [],
            locations: [],
            bundles: [],
            staffList: [],
            client_id: null,
            CLINIC_PROVIDER_ALERT: CLINICPROVIDER.CLINIC_PROVIDER_ALERT
        };
    },
    computed: {
        bundle_options_exclude() {
            return difference(this.bundles, this.data.bundle_id);
        },
        isBundle() {
            if (this.data.bundle_id.length > 0) {
                return false;
            }

            return true;
        },
        isClientExist() {
            return !isEmpty(this.client);
        }
    },
    watch: {
        "data.client": {
            handler(newData, oldData) {
                let self = this;
                self.data.client_id = newData ? newData.id : null;
                self.data.type = newData ? 0 : 1;
                self.poptions = [];

                if (newData) {
                    this.data.patient_id = null;
                    this.data.patient = null;
                    this.getLocations(newData.id).then(locations => {
                        if (self.$root.setting.location == 1) {
                            self.data.location = find(locations, {
                                id: newData.id
                            });
                        } else {
                            self.data.location = null;
                        }
                    });
                } else {
                    this.data.patient_id = null;
                    this.data.patient = null;
                    self.data.location = null;
                    self.locations = [];
                }
            }
        },
        "data.patient": {
            handler(newData, oldData) {
                let self = this;
                self.data.patient_id = newData ? newData.id : null;
                self.getLatestVital(self.data.patient_id);
            }
        },
        "data.start": {
            handler(newData, oldData) {
                if (newData) {
                    $("#start").removeClass("border-danger");
                } else {
                    $("#start").addClass("border-danger");
                }
            }
        },
        "data.expire": {
            handler(newData, oldData) {
                if (newData) {
                    $("#expire").removeClass("border-danger");
                } else {
                    $("#expire").addClass("border-danger");
                }
            }
        },
        "data.staff": {
            handler(newData, oldData) {
                if (newData !== "") {
                    if (this.staffList.length === 0) {
                        this.data.staff = null;
                    } else {
                        this.setStaffId();
                    }
                }
            }
        }
    },
    mounted() {
        this.loading = true;

        this.datePickerOptions.format = this.getDateFormat();
        if (!isEmpty(this.client)) {
            this.client_id = this.client.id;
            this.data.client = this.client;
        }

        this.data.start = moment().tz(this._timeZone);
        this.data.expire = moment()
            .tz(this._timeZone)
            .add(this._setting.estimate_expiration, this.getTimePeriod());

        this.getStaffList();

        this.$nextTick(() => {
            // put all initialize process into promise
            this.$emit("beforeload");

            let process = [this.getBundle()];

            if (this.client_id) {
                process.push(this.getLocations(this.client_id));
            }

            this.$emit("loading");
            Promise.all(process).then(() => {
                this.$emit("loaded");
                // this.data.bundle_id = this.bundles[0].id;
            });

            this.$validator.reset();
            this.loading = false;
        });
    },
    methods: {
        getStaffList() {
            let self = this;
            this.$http
                .get(process.env.ACTOR_SERVICE + "staff?provider=1")
                .then(function (response) {
                    self.staffList = response.data.response.resources;
                });
        },
        setStaffId() {
            let self = this;
            let defaultClinicProvider = find(self.staffList, [
                "is_default_provider",
                true
            ]);

            if (defaultClinicProvider) {
                self.data.isDefaultProvider =
                    self.data.staff.id == defaultClinicProvider.id;
            }
        },
        getLocations(clientId) {
            return Client.getLocations(clientId).then(response => {
                this.locations = response.resources;
                if (this.data.appointmentLocation) {
                    this.data.location = find(this.locations, {
                        id: this.data.appointmentLocation.location_id
                    });
                }
                return this.locations;
            });
        },
        getBundle() {
            Templates.getBundles({
                type: [TEMPLATES.TYPE.BUNDLE, TEMPLATES.TYPE.BUNDLE_ESTIMATE]
            }).then(response => {
                this.bundles = response.resources.map(bundle => {
                    const typeString =
                        parseInt(bundle.type) == TEMPLATES.TYPE.BUNDLE
                            ? "(Invoice)"
                            : parseInt(bundle.type) ==
                              TEMPLATES.TYPE.BUNDLE_ESTIMATE
                            ? "(Estimate)"
                            : "";
                    bundle.name = `${bundle.name} ${typeString}`;
                    return bundle;
                });
            });
        },
        getTimePeriod() {
            let self = this;
            self.data.time_period = "days";

            switch (self._setting.estimate_time_period) {
                case 4:
                    self.data.time_period = "days";
                    break;
                case 6:
                    self.data.time_period = "months";
            }

            return self.data.time_period;
        },
        async getLatestVital(patientId) {
            let res = await Patient.getLatestVital(patientId);

            if (res && res.message?.code == 200) {
                let weightData = find(res.resources, item => {
                    return get(item, "vital_label.id") === 4;
                });
                this.data.weight = Number(weightData.value);
                this.data.uom = weightData.master_uom_id;
            }
        }
    }
};
</script>
